/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `RouteIconProps` interface defines the properties for the RouteIcon component.
 */
interface RouteIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "route" — outlined, weight 300.
 * Route icon for distance display.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const RouteIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'RouteIcon',
    width
}: RouteIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M360-200q-66 0-113-47t-47-113q0-66 47-113t113-47q19 0 37.5 4.5T432-502l172-172q-9-16-13.5-34.5T586-744q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47q-19 0-37.5-4.5T674-602L502-430q9 16 13.5 34.5T520-360q0 66-47 113t-113 47Zm0-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm386-384q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM360-360Zm386-384Z" />
    </svg>
);

RouteIcon.displayName = 'RouteIcon';